import { useEffect, useState } from "react";
import CandidateInfoListItem from "./CandidateInfoListItem";
import styles from "../../../styles/candidate/parts/CandidateInfoList.module.scss";

const CandidateInfoList = ({
  data,
  items,
  requiresReset,
  setRequiresReset,
  type,
  contestName,
  candidacyId
}) => {
  const [activeSelection, setActiveSelection] = useState(-1);

  useEffect(() => {
    if (requiresReset) {
      setActiveSelection(-1);
      setRequiresReset(false);
    }
  }, [requiresReset, setRequiresReset]);

  const toggleActiveSelection = (index) => {
    if (activeSelection !== index) {
      setActiveSelection(index);
    } else {
      setActiveSelection(-1);
    }
  }

  return (
    <div className={styles.candidateInfoList}>
      {
        type === 'topQuestions' && items && items.content.map((item, index) =>
          <div
            className={styles.candidateInfoListItemAccordion}
            onClick={() => toggleActiveSelection(index)}
            key={index}
          >
            <CandidateInfoListItem index={index} data={{...item, activeSelection}} type={'accordionItem'}></CandidateInfoListItem>
          </div>
        )

      }
      {/* TO UNCOMMENT IF ORIGINAL STRUCTURE IS IMPLEMENTED */}
      {/* {
        type === 'topQuestions' &&
        <CandidateInfoListItem
          data={{
            ...data,
            content: 'Did the TRAIN law extinguish Bongbong Marcos’ crime?'
          }}
          type={'specialListItem'}
        />
      } */}
      {
        type === 'promises' && items && items?.content?.map((item, index) =>
          <CandidateInfoListItem
            key={index}
            data={{ ...item }}
            type={'snippet'}
            compareButtonLabel={'Compare this promise with other candidates'}
            contestName={contestName}
            candidacyId={candidacyId}
          />
        )
      }
      {
        type === "stances" && items && items?.content?.map((item, index) =>
          <CandidateInfoListItem
            key={index}
            data={{ ...item }}
            type={'position'}
            contestName={contestName}
            candidacyId={candidacyId}
          />
        )
      }
      {
        type === "highlightsControversies" && items && items.content.map((item) => {
          return item.content.map((contentPiece) => {
              return <CandidateInfoListItem
                key={item.key}
                innerRef={`highlights-${item.key}`}
                data={{ ...contentPiece, category: item.key.includes("_0") ? item.category : "" }}
                type={'article'}
              />
          })
        })
      }
    </div>
  );
};

export default CandidateInfoList;
